
import { Component, Vue, Watch } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';

import ConfirmModal from '@/shared/components/ConfirmModal.vue';
import formatNumber from '@/shared/filters/format-number';
import Paging from '@/shared/components/Paging.vue';

import { DATA } from '@/config/data';
import { APP_CONFIG } from '@/config/app-config';

import { SummaryDepositModel } from '@/models/summary-deposit';
import { DepositModel } from '@/models/deposit';

import ListDeposit from './components/ListDeposit.vue';
import FilterBox from './components/FilterBox.vue';

import depositServices from '@/services/deposit-services';
import SummaryOrder from './components/SummaryOrder.vue';
import authService from '@/services/auth-services';
import commonService from '@/services/common-services';
import { CommonActionType } from '@/store/modules/common/action.type';
@Component({
    components: {
        ListDeposit,
        FilterBox,
        Loading,
        Paging,
        ConfirmModal,
        SummaryOrder
    }
})
export default class MainDeposit extends Vue {
    private filterProp = {
        selectedStatus: { value: -1, name: 'Tất cả', color: '#fff' },
        searchText: ''
    };
    private pageSettings = {
      rowPerPage: 15,
      pageSize: 6,
      pageIndex: 1,
      total: 0,
    };
    
    private summaryOrder: SummaryDepositModel = new SummaryDepositModel();
    private listDeposit: DepositModel[] = [];
    private isLoading = false;
    private chinaAddress = '';
    private showNextConfirm = true;
    private isConfirm = false;
    private modalContent = 'Bạn có thực sự muốn hủy đơn hàng này không?';
    private actions = {
        cancel: 'cancel',
        payment: 'payment',
        request: 'request',
        new: 'new'
    };
    private actionSelected: any = this.actions.cancel;
    zeroPad = (num, places) => String(num).padStart(places, '0');

    get showMenu() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
    }

    get customerInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].customerInfo;
    }

    get productTypes() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].productTypes;
    }

    get totalChoose() {
        return this.listDeposit.filter(x => x.isChecked === true).length;
    }

    get amountNeedPayment() {
        return this.listDeposit.reduce((amount: number, x: DepositModel) => {
            return amount + (x.isChecked === true && ((x.status === 7 || x.status === 9) && x.payStatus === 'Chưa thanh toán') ? (x.totalPriceVND - x.payment) || 0 : 0)
        }, 0);
    }

    private async getCustomersInfo() {
        const result = await authService.customersInfo(this.customerInfo.ID);
        if(result && result.status === 200) {
            (window['getApp'] as any).$emit('APP_SET_CUSTOMER_INFO', result.data.data || {});
        }
    }

    private getProductTypeDetail(value: any) {
        const item = this.productTypes ? this.productTypes.find(x => x.ID === value) : null;
        return item ? item.Name : '--';
    }

    private async getConfig() {
      const result = await commonService.getDetailChinaStore(this.customerInfo.ChinaStoreID);

      if (result && result.status === 200) {
        this.chinaAddress = `${result.data.data.Receiver}${this.customerInfo.ID} - ${result.data.data.Phone} - ${result.data.data.Address.replaceAll('DL', 'DL'+this.customerInfo.ID)}`;
        this.$store.dispatch(`${APP_CONFIG.stateKey.commonStore}/${CommonActionType.SetChinaAddress}`, this.chinaAddress);
      }
    }

    private async created() {
        this.loadData();
        if (!this.productTypes) {
            await this.getProductTypes();
        }
    }

    private async loadData() {
        this.isLoading = true;
        this.pageSettings.total = 0;
        const filters: any = this.onBuildFilter();
        this.summaryOrder = new SummaryDepositModel();
        this.getCustomersInfo();
        this.getConfig();
        const result = await depositServices.getDeposit(this.pageSettings.pageIndex, this.pageSettings.rowPerPage, filters.filters, filters.quickFilters);
        this.isLoading = false;
        if (result && result.data && result.data.status === 200) {
            const tmpListDeposit: DepositModel[] = [];
            this.pageSettings.total = result.data.total;
            this.summaryOrder = {
                TotalStatusAll: result.data.summary.TotalStatusAll || 0,
                TotalStatus1: result.data.summary.TotalStatus1 || 0,
                TotalStatus7: result.data.summary.TotalStatus7 || 0,
                TotalStatus9: result.data.summary.TotalStatus9 || 0,
                TotalStatus10: result.data.summary.TotalStatus10 || 0,
                TotalStatus11: result.data.summary.TotalStatus11 || 0,
                TotalStatus12: result.data.summary.TotalStatus12 || 0,
                TotalStatus16: result.data.summary.TotalStatus16 || 0,
                TotalAmountStoreVN: result.data.summary.TotalAmountStoreVN || 0,
                TotalLeftStoreVN: result.data.summary.TotalLeftStoreVN || 0,
                TotalExported: result.data.summary.TotalExported || 0,
                TotalExportedNotPay: result.data.summary.TotalExportedNotPay || 0,
            };

            for (const item of result.data.data) {
                const deposit = new DepositModel();
                deposit.id = item.ID;
                deposit.depositCode = item.DepositCode;
                deposit.packageCode = item.PackageCode;
                deposit.numberOfPack = item.NumberOfPack;
                deposit.uId = item.UID;
                deposit.userName = item.Username;
                deposit.status = item.Status;
                deposit.payStatus = item.PayStatus;
                deposit.statusDetail = DATA.depositStatus.find(x => x.value === item.Status) || { value: 0, name: 'Khác', color: '#3b4354' };
                deposit.orderWeight = item.OrderWeight;
                deposit.orderVolume = item.OrderVolume;
                deposit.unpaidWeight = item.UnpaidWeight;
                deposit.totalPriceVND = item.TotalPriceVND;
                deposit.productType = this.getProductTypeDetail(item.ProductType);
                deposit.payment = item.Payment;
                deposit.createdDate = item.CreatedDate;
                deposit.ProductName = item.ProductName;
                deposit.ProductImage = item.ProductImage ? item.ProductImage : '';

                tmpListDeposit.push(deposit);
            }
            this.listDeposit = tmpListDeposit;
        }
    }

    private onBuildFilter() {
        const paramsFilter: any = {
            filters: [],
            quickFilters: []
        };
        if (this.filterProp.selectedStatus.value !== -1) {
            paramsFilter.filters.push({
                column: 'Status',
                value: this.filterProp.selectedStatus.value,
                condition: 'equal'
            });
        }

        if (this.filterProp.searchText !== null &&
            this.filterProp.searchText !== undefined &&
            this.filterProp.searchText !== '') {
                paramsFilter.quickFilters.push({
                    column: 'DepositCode',
                    value: this.filterProp.searchText,
                    condition: 'contain'
                });
                paramsFilter.quickFilters.push({
                    column: 'ID',
                    value: this.filterProp.searchText.toUpperCase().replace('KG', ''),
                    condition: 'contain'
                });
        }

        return paramsFilter;
    }

    private async getProductTypes() {
        const result = await commonService.getProductType();
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_PRODUCT_TYPE', result.data.data);
        }
    }

    private createNewDeposit() {
        const routeData = this.$router.resolve({ name: 'deposit-new' });
        window.open(routeData.href, '_blank');
    }

    private onFilterChanged(data: any) {
        this.filterProp.selectedStatus = data.status;
        this.filterProp.searchText = data.searchText;
        this.pageSettings.pageIndex = 1;
        this.loadData();
    }

    private onChangePage(data: any) {
        this.pageSettings.pageIndex = data;
        this.loadData();
    }

    private async onCheckAll(isCheckAll: boolean) {
        this.listDeposit = this.listDeposit.map(x => {
            return {
                ...x,
                isChecked: ((x.unpaidWeight > 0 || x.status === 9) && x.totalPriceVND > x.payment) ? isCheckAll : x.isChecked
            }
        });
    }

    private async onActionStatus(action: any) {
        this.actionSelected = action;
        await this.getCustomersInfo();
        if (this.actionSelected !== this.actions.new && this.totalChoose === 0) {
            Vue.notify({group: 'foo',type: 'error',title: 'Thông báo!',text: 'Không có đơn hàng nào được chọn!'});
            return false;
        }
        switch(this.actionSelected) {
            case this.actions.payment: {
                const countNoWaitPayment = this.listDeposit.filter(x => !((x.unpaidWeight > 0 || x.status === 9) && x.totalPriceVND > x.payment) && x.isChecked === true).length;
                if (countNoWaitPayment > 0) {
                    Vue.notify({group: 'foo',type: 'warn',title: 'Thông báo!',text: 'Chức năng này chỉ dành cho những đơn có kiện NHẬP KHO VN!'});
                    return false;
                }
                if (this.customerInfo.Wallet >= this.amountNeedPayment) {
                    const listDeposit = this.listDeposit.filter(x => ((x.unpaidWeight > 0 || x.status === 9) && x.totalPriceVND > x.payment) && x.isChecked === true);
                    this.modalContent = this.onModalContentPayment(listDeposit, this.amountNeedPayment);
                    this.isConfirm = true;
                    this.showNextConfirm = true;
                } else {
                    this.modalContent = `<div style="color: #111;">Số tiền trong ví của bạn không đủ để thanh toán.</div>
                                        <div>Tiền cần trả: <span class="fb">${formatNumber(this.amountNeedPayment, '0,0')} VND</span></div>
                                        <div>Ví: <span class="fb">${formatNumber(this.customerInfo.Wallet, '0,0')} VND</span></div>
                                        <div class="text-danger">Hãy nạp tiền để tiếp tục thanh toán!</div>`;
                    this.isConfirm = true;
                    this.showNextConfirm = false;
                }
                break;
            }
            case this.actions.new: {
                const routeData = this.$router.resolve({ name: 'deposit-new' });
                window.open(routeData.href, '_blank');
            }  
        }
    }

    private onModalContentPayment(listDeposit: DepositModel[], amountNeedDeposit) {
        let modalContent = `<div class="modal-happy">Bạn có muốn thanh toán cho <span class="fb text-danger">${listDeposit.length}</span> đơn dưới đây không?
                                <div class="table-responsive">
                                    <table class="table table-bordered table-happy nomargin">
                                        <thead>
                                            <tr>
                                                <th>Mã đơn</th>
                                                <th>Tổng tiền</th>
                                                <th>Đã trả</th>
                                                <th>Còn thiếu</th>
                                            </tr>
                                        </thead>
                                        <tbody>`;
        for(const order of listDeposit) {
            modalContent += `<tr>`;
            modalContent += `<td>KG${order.id}</td>`;
            modalContent += `<td class="text-right">${ formatNumber(order.totalPriceVND, '0,0') }</td>`;
            modalContent += `<td class="text-right">${ formatNumber(order.payment, '0,0') }</td>`;
            modalContent += `<td class="text-right">${ formatNumber(order.totalPriceVND - order.payment, '0,0') }</td>`;
            modalContent += `</tr>`;
        }

        modalContent += `<tr>
                            <td colspan="3" class="text-right fb">
                                <span class="text-right fb">Tổng tiền thiếu</span>
                            </td>
                            <td class="text-right fb">${ formatNumber(amountNeedDeposit, '0,0') }</td>
                        </tr>`;
        modalContent += `<tr>
                            <td colspan="3" class="text-right fb">
                                <span class="text-right fb">Số dư ví</span>
                            </td>
                            <td class="text-right fb">${ formatNumber(this.customerInfo.Wallet, '0,0') }</td>
                        </tr>`;
        modalContent += `<tr>
                            <td colspan="3" class="text-right fb">
                                <span class="text-right fb">Cần nạp thêm</span>
                            </td>
                            <td class="text-right fb">${ formatNumber(amountNeedDeposit > this.customerInfo.Wallet ? amountNeedDeposit - this.customerInfo.Wallet : 0, '0,0') }</td>
                        </tr>`;
        modalContent += `</tbody>
                    </table>
                </div>`;
        return modalContent;
    }

    private async submitPaymentOrder() {
        this.isLoading = true;
        const dataRequest = {
            type: 9,
            ids: this.listDeposit
                    .filter(x => ((x.unpaidWeight > 0 || x.status === 9) && x.totalPriceVND > x.payment) && x.isChecked === true)
                    .map(x => x.id)
        }
        const result = await depositServices.updateMultiple(dataRequest);

        if (result && result.status === 200 && result.data.data.status === true) {
            // const items = this.listDeposit.filter(x => (x.unpaidWeight > 0) && x.isChecked === true).map(x => {
            //     return {
            //         id: x.id,
            //         orderType: 2,
            //         orderWeight: x.orderWeight,
            //         totalAmountVND: x.totalPriceVND,
            //         deposit: x.payment,
            //         isChecked: true
            //     }
            // });
            // if(items.length > 0) {
            //     (window['getApp'] as any).$emit('SET_SELECTED_ORDER', items);
            //     this.actionSelected = this.actions.request;
            //     this.modalContent = `<div style="color: #111; font-size: 16px; font-weight: 700;">Thanh toán đơn hàng thành công.</div>
            //     <div style="color: #d9534f; font-size: 16px; font-weight: 700;">Hãy tạo yêu cầu giao để ngay để kho gửi hàng cho bạn sớm nhất!</div>`;
            //     this.isConfirm = true;
            //     this.showNextConfirm = true;
            // } else {
            //     Vue.notify({group: 'foo',type: 'success',title: 'Thông báo!',text: 'Thanh toán đơn hàng thành công!'});
            // }
            Vue.notify({group: 'foo',type: 'success',title: 'Thông báo!',text: 'Thanh toán đơn hàng thành công!'});
            this.getCustomersInfo();
            this.loadData();
        } else {
            this.isLoading = false;
        }
    }

    private onAcceptModal(eventData: any) {
        this.isConfirm = !eventData.close || false;
        if (eventData.data === 'OK' && this.actionSelected === this.actions.payment) {
            this.submitPaymentOrder();
        } else if (eventData.data === 'OK' && this.actionSelected === this.actions.request) {
            this.$router.push({ name: 'yeu-cau-giao-hang2' });
        }
    }

    private onCloseModal(eventData: any) {
        this.isConfirm = !eventData.close || false;
    }
}
